import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Match } from '../../_shared/models/match.model';
import { TournamentDetailsService } from './tournament-details.service';
import { MatchService } from '../../_core/services/match.service';
import { MatchUpStatusEnum } from '../../_shared/models/csTypes/enums/matchup_status';
import { AuthService } from '../../auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Tournament } from '../../_shared/models/tournament.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';

class Filters {
    venueId?: string;
    matchStatus?: string;
    dates?: string[];
}
@Component({
  standalone: false,
    selector: 'app-tournament-details',
    templateUrl: './tournament-details.component.html',
    styleUrls: ['./tournament-details.component.scss'],
})
export class TournamentDetailsComponent implements OnInit, OnDestroy {
    authService = inject(AuthService);
    tournamentDetailsService = inject(TournamentDetailsService);
    activatedRoute = inject(ActivatedRoute);
    bhs = inject(BoardHelpService);
    showBadge = false;
    liveScoreBadge = 0;
    completedBadge = 0;
    private destroyed$: Subject<void> = new Subject();
    tournament: Tournament;
    isShow: boolean = true;

    constructor(
        private matchService: MatchService
    ) { }

    async ngOnInit() {
        this.tournament = await this.tournamentDetailsService.getTournamentInfo(this.activatedRoute.snapshot.params.id);
        this.isShow = this.canViewDrawTab();
        this.subscriptions();
    }

    canViewDrawTab(): boolean {
        return this.tournament?.partner?.toLowerCase() === 'tmx';
    }
    
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    private subscriptions() {
        // If a match is completed during live scoring get that the match is completed
        // And move to Results tab
        this.matchService
            .subscribeEdit()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(
                (updatedMatchUp: Match) => {
                    if (updatedMatchUp.matchStatus === MatchUpStatusEnum.COMPLETED ||
                        updatedMatchUp.matchStatus === MatchUpStatusEnum.RETIRED ||
                        updatedMatchUp.matchStatus === MatchUpStatusEnum.INCOMPLETE) {
                        this.completedBadge++;
                    }
                }
            );

        this.tournamentDetailsService
            .subscribeClearBadge()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(
                value => {
                    switch (value) {
                        case 'live-score':
                            this.liveScoreBadge = 0;
                            break;
                        case 'completed':
                            this.completedBadge = 0;
                            break;
                        default:
                            break;
                    }
                }
            );
        this.tournamentDetailsService.getTournamentAfterToggleAllowFansToScore()
            .pipe(takeUntil(this.destroyed$))
            .subscribe((allowFansToScore) => {
                this.getTournamentAfterToggleAllowFansToScore();
            });
    }

    canViewPlayerTab(): boolean {
        return this.tournament?.features?.includes('PARTICIPANTS') && this.tournament?.trackers.some(t => t.tracker._id === this.authService.authUserSignal()?._id)
    }

    canViewStandingsTab(): boolean {
        return this.tournament?.features?.includes('STANDINGS')
    }

    async getTournamentAfterToggleAllowFansToScore() {
        this.tournament = await this.tournamentDetailsService.getTournamentInfo(this.activatedRoute.snapshot.params.id, true);
    }

}
